import { Component, OnInit, Input, ViewChild, ElementRef, AfterViewInit, Output, EventEmitter, HostListener } from '@angular/core';
import { OperationsService } from '../../../../services/operations.service';
import { ComponentCanDeactivate } from '../../../../ComponentCanDeactivate';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-shipment-scanning',

  templateUrl: './shipment-scanning.component.html',
  styleUrls: ['./shipment-scanning.component.scss']
})
export class ShipmentScanningComponent  implements OnInit, AfterViewInit  {

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any) {
    if (this.receivedShipments.length > 0) {
      $event.returnValue = true;
    }
  }
  constructor(
    private operationsService: OperationsService,
    private translate: TranslateService
  ) { }
  @Input() shipments = []
  penddingShipments = [];
  @Output() onCloseTrip = new EventEmitter()

  @ViewChild('scannerInput', { read: false }) scannerInput: ElementRef;
  @ViewChild('aslInput', { read: false }) aslInput: ElementRef;
  @ViewChild('keyboardInput', { read: false }) keyboardInput: ElementRef;
  ngOnInit() {
  }
  lockScannerFoucs = true;
  aslEnabled = false;
  errorMessage = "";
  asl = "";
  onBlur(event) {
    if (this.lockScannerFoucs) {
     this.scannerInput.nativeElement.focus();
    }
  }
  changeFouceToKeyboard() {
    this.lockScannerFoucs = false;
    this.keyboardInput.nativeElement.focus();

  }
  onBlurAsl(event) {
    this.lockScannerFoucs = true;
    this.scannerInput.nativeElement.focus();
  }
  ngAfterViewInit() {
    this.penddingShipments = this.shipments;
    this.scannerInput.nativeElement.focus();

  }
  enableAsl() {
    this.aslEnabled = !this.aslEnabled;
    if (this.aslEnabled == true) {
      this.lockScannerFoucs = false;
      this.aslInput.nativeElement.focus();
    }
    else {
      this.lockScannerFoucs = true;
      this.scannerInput.nativeElement.focus();
    }

  }
  shipmentNumber = ""
  showShipmentNotFound = false;
  startScanning = false;

  onDetected($event) {
    if ($event.type == 'scanner') {
      this.startScanning = true;
      setTimeout(() => {
        if (this.penddingShipments.findIndex(m => m.ShipmentNumber == this.shipmentNumber) != -1) {
         // console.log(this.shipmentNumber)
          var number = this.shipmentNumber;
          this.showShipmentNotFound = false
          let shipmentIndex = this.shipments.findIndex(m => m.ShipmentNumber == this.shipmentNumber)
          this.extractToReceviedShipment(shipmentIndex)
          //this.operationsService.scanShipment(this.shipmentNumber, this.asl,
          //  (res) => {
              
          //    this.startScanning = false;
          //  }, (err) => {
          //    this.startScanning = false;
          //  })
          this.shipmentNumber = "";

        }
        else if (this.shipmentNumber != "") {
          this.showShipmentNotFound = true
          this.shipmentNumber = ""
          this.startScanning = false;
          this.errorMessage = `${this.translate.instant('pages.shipmentReceiving.shipmentScanning.droppedOffMsg')}`;
        }
      }, 300);
    }
    
  }
  closeTrip() {
    if (this.receivedShipments.length == 0) {
      this.showShipmentNotFound = true;

      this.errorMessage = `${this.translate.instant('pages.shipmentReceiving.shipmentScanning.scanShipmentMsg')}`
      return;
    }
    else {
      this.showShipmentNotFound = false;
      var receivedShipments = [];
      var penddingShipments = [];
      this.receivedShipments.forEach((s) => {
        receivedShipments.push(s.ShipmentNumber + "-" + s.asl);
      });
      this.penddingShipments.forEach((s) => {
        penddingShipments.push(s.ShipmentNumber);
      });
      this.operationsService.closeTrip(this.receivedShipments[0].TripId, receivedShipments, penddingShipments, (res) => {
        if (res == true) {
          this.onCloseTrip.emit(true)
        }
        else {
          this.showShipmentNotFound = true;
          this.errorMessage = `${this.translate.instant('pages.shipmentReceiving.shipmentScanning.tripStatusErrorMsg')}`;
        }
      }, (err) => {

      })
    }
  }
  scan(event) {
    if (this.penddingShipments.findIndex(m => m.ShipmentNumber == this.shipmentNumber) != -1) {
      this.showShipmentNotFound = false;
      let shipmentIndex = this.shipments.findIndex(m => m.ShipmentNumber == this.shipmentNumber)
      this.extractToReceviedShipment(shipmentIndex)
    }
    else {
      this.showShipmentNotFound = true
      this.shipmentNumber = ""
      this.startScanning = false;
      this.errorMessage = `${this.translate.instant('pages.shipmentReceiving.shipmentScanning.droppedOffMsg')}`;
    }
  }
  receivedShipments = [];
  extractToReceviedShipment(shipmentIndex) {
    //console.log(shipmentIndex);
    const index = this.penddingShipments.indexOf(this.penddingShipments[shipmentIndex]);
    if (index > -1) {
      this.penddingShipments[shipmentIndex].asl = this.asl;
      this.receivedShipments.push(this.penddingShipments[shipmentIndex])
      this.penddingShipments.splice(index, 1);
    }

  }
}
